module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-todo@2x-b69c8da4b5bf8cffa1ed54cbc724fa38.png";